import { createSlice } from "@reduxjs/toolkit";

const recommendedPlansSlice = createSlice({
  name: "recommendedPlan",
  initialState: {},
  reducers: {
    addRecommendedPlan(state, action) {
      return Object.assign({}, state, action.payload);
    },
    updateRecommendedPlan(state, action) {
      return Object.assign({}, state, action.payload);
    },
  },
});

export const {
  addRecommendedPlan,
  updateRecommendedPlan,
} = recommendedPlansSlice.actions;

export default recommendedPlansSlice.reducer;
